module.exports = __webpack_public_path__ + "img/indian-cove-ranch-splash.fe3e2707.jpg";